import { render, staticRenderFns } from "./moreDetails.vue?vue&type=template&id=6cc9b912&scoped=true&"
import script from "./moreDetails.vue?vue&type=script&lang=js&"
export * from "./moreDetails.vue?vue&type=script&lang=js&"
import style0 from "./moreDetails.vue?vue&type=style&index=0&id=6cc9b912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc9b912",
  null
  
)

export default component.exports